import Keycloak from "keycloak-js";
import { appConfig } from "./appConfig";

export const keycloak = Keycloak(appConfig.keycloak);
